import React, { useEffect, useState } from 'react';
import { WA_HREF, WhatsIcon } from './WhatsButton';
import { trackWhatsAppClick } from '../../utils/analytics';

export const MobileStickyCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const cta = document.querySelector('[data-testid="hero-whatsapp-cta"]');
      setShow(Boolean(cta) && cta.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <a
      href={WA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick('short-sticky')}
      data-testid="sticky-whatsapp-cta"
      className={`lg:hidden fixed bottom-4 inset-x-4 z-50 flex items-center justify-center gap-3 rounded-xl bg-[var(--sh-teal)] text-[#06110F] py-3.5 font-bold shadow-2xl transition-[transform,opacity] duration-300 ${show ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0 pointer-events-none'}`}
    >
      <WhatsIcon className="w-6 h-6" />
      <span className="sh-display text-2xl">Solicite seu orçamento</span>
    </a>
  );
};
